var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fzf"},[_c('div',{staticClass:"fzfbox"},[_c('strong',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.text)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-597c2e06","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/paysuccess.vue
// module id = null
// module chunks = 